import { types } from '../reducers/vodReducer';

// eslint-disable-next-line import/prefer-default-export
export const createVoD = (values) => ({
  type: types.DRAFT_POST,
  payload: values,
});

export const updateVoD = (values) => ({
  type: types.PUT,
  payload: values,
});

export const removeVoD = (item) => ({
  type: types.DELETE,
  item,
});

export const reloadVoD = (items) => ({
  type: types.RELOAD,
  payload: items,
});

export const resetVoD = () => ({
  type: types.RESET,
});

export { getDraftId } from '../reducers/vodReducer';
